import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-31ce41f4")

_pushScopeId("data-v-31ce41f4")
const _hoisted_1 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_2 = { class: "name-wrapper" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Deleted")
const _hoisted_4 = { class: "dialog-footer" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Cancel")
const _hoisted_6 = { style: {"word-break":"break-word"} }
const _hoisted_7 = /*#__PURE__*/_createVNode("h4", null, "To pay with an alternative card or PayPal, please change the default payment method in My Profile -> My Payments -> Set default", -1)
const _hoisted_8 = { style: {"text-align":"right"} }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Cancel ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Pay Now ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_tag = _resolveComponent("el-tag")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_tooltip = _resolveComponent("el-tooltip")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_empty = _resolveComponent("el-empty")
  const _component_InvoiceDetailPage = _resolveComponent("InvoiceDetailPage")
  const _component_el_dialog = _resolveComponent("el-dialog")

  return (_openBlock(), _createBlock("div", null, [
    (_ctx.listInvoices.length > 0)
      ? (_openBlock(), _createBlock(_component_el_table, {
          key: 0,
          data: _ctx.listInvoices,
          onSelectionChange: _ctx.handleSelectionChange
        }, {
          default: _withId(() => [
            _createVNode(_component_el_table_column, {
              type: "selection",
              width: "55"
            }),
            _createVNode(_component_el_table_column, {
              prop: "idView",
              label: "#",
              "min-width": "130"
            }),
            _createVNode(_component_el_table_column, {
              label: "Connection Name",
              "min-width": "140"
            }, {
              default: _withId((item) => [
                (item.row.connections)
                  ? (_openBlock(true), _createBlock(_Fragment, { key: 0 }, _renderList(item.row.connections, (connect) => {
                      return (_openBlock(), _createBlock(_Fragment, { key: connect }, [
                        (!connect.from)
                          ? (_openBlock(), _createBlock(_component_el_tag, {
                              key: 0,
                              size: "small"
                            }, {
                              default: _withId(() => [
                                _createTextVNode(_toDisplayString(connect.connection !== null ? connect.connection.name : null), 1)
                              ]),
                              _: 2
                            }, 1024))
                          : _createCommentVNode("", true)
                      ], 64))
                    }), 128))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            (_ctx.isSuperAdmin)
              ? (_openBlock(), _createBlock(_component_el_table_column, {
                  key: 0,
                  label: "Company Name",
                  prop: "companyName",
                  "min-width": "180"
                }, {
                  default: _withId((item) => [
                    _createVNode("span", null, _toDisplayString(item.row.account && item.row.account.name
              ? item.row.account.name
              : 'N/A'), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.isSuperAdmin)
              ? (_openBlock(), _createBlock(_component_el_table_column, {
                  key: 1,
                  label: "Email Address",
                  prop: "emailAddress",
                  "min-width": "210",
                  "show-overflow-tooltip": ""
                }, {
                  default: _withId((item) => [
                    _createVNode("span", null, _toDisplayString(item.row.account &&
            item.row.account.owner &&
            item.row.account.owner.email
              ? item.row.account.owner.email
              : 'N/A'), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_el_table_column, {
              label: "Issue Date",
              prop: "dateCreated",
              "min-width": "110"
            }, {
              default: _withId((item) => [
                _createVNode("span", null, _toDisplayString(new Date(item.row.dateCreated).toLocaleString('en-US', {
              day: '2-digit',
              month: '2-digit',
              year: 'numeric'
            })), 1),
                _hoisted_1,
                _createVNode("span", null, _toDisplayString(new Date(item.row.dateCreated).toLocaleString('en-GB', {
              hour: '2-digit',
              minute: '2-digit',
              second: '2-digit'
            })), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "Total",
              prop: "total.$numberDecimal"
            }, {
              default: _withId((item) => [
                _createVNode("span", null, "$" + _toDisplayString(parseFloat(item.row.total).toFixed(2)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "Status",
              prop: "status"
            }, {
              default: _withId((scope) => [
                _createVNode("div", _hoisted_2, [
                  (scope.row.dateDeleted)
                    ? (_openBlock(), _createBlock(_component_el_tag, {
                        key: 0,
                        size: "medium",
                        type: "info"
                      }, {
                        default: _withId(() => [
                          _hoisted_3
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                        (scope.row.status === 'Issued')
                          ? (_openBlock(), _createBlock(_component_el_tag, {
                              key: 0,
                              size: "medium",
                              type: "danger"
                            }, {
                              default: _withId(() => [
                                _createTextVNode(_toDisplayString(scope.row.status), 1)
                              ]),
                              _: 2
                            }, 1024))
                          : (_openBlock(), _createBlock(_component_el_tag, {
                              key: 1,
                              size: "medium"
                            }, {
                              default: _withId(() => [
                                _createTextVNode(_toDisplayString(scope.row.status), 1)
                              ]),
                              _: 2
                            }, 1024))
                      ], 64))
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "Inspect",
              fixed: "right",
              "min-width": "140"
            }, {
              default: _withId((scope) => [
                _createVNode(_component_el_tooltip, {
                  class: "item",
                  effect: "light",
                  content: "Detail",
                  placement: "bottom"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_button, {
                      size: "small",
                      onClick: ($event: any) => (_ctx.viewDetail(scope.row)),
                      icon: "el-icon-document",
                      type: "primary"
                    }, null, 8, ["onClick"])
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_el_tooltip, {
                  class: "item",
                  effect: "light",
                  content: "Download to PDF file",
                  placement: "bottom"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_button, {
                      size: "small",
                      type: "success",
                      onClick: ($event: any) => (_ctx.clickDownload(scope.row)),
                      icon: "el-icon-download"
                    }, null, 8, ["onClick"])
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_el_tooltip, {
                  class: "item",
                  effect: "light",
                  content: "Download to CSV file",
                  placement: "bottom"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_button, {
                      size: "small",
                      type: "default",
                      onClick: ($event: any) => (_ctx.clickDownload(scope.row, 'csv')),
                      icon: "el-icon-download"
                    }, null, 8, ["onClick"])
                  ]),
                  _: 2
                }, 1024),
                (scope.row.type === 'custom' && scope.row.status ==='Issued' && _ctx.ListCards?.length)
                  ? (_openBlock(), _createBlock(_component_el_tooltip, {
                      key: 0,
                      class: "item",
                      effect: "light",
                      content: "Pay Now",
                      placement: "bottom"
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_button, {
                          size: "small",
                          type: "default",
                          onClick: ($event: any) => (_ctx.showPayNowPopup(scope.row)),
                          icon: "el-icon-bank-card"
                        }, null, 8, ["onClick"])
                      ]),
                      _: 2
                    }, 1024))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data", "onSelectionChange"]))
      : (_openBlock(), _createBlock(_component_el_empty, {
          key: 1,
          description: "You don't have any invoice yet!"
        })),
    _createVNode(_component_el_dialog, {
      title: "Invoice Detail",
      modelValue: _ctx.dialogInvoiceDetail,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.dialogInvoiceDetail = $event)),
      width: "700px"
    }, {
      footer: _withId(() => [
        _createVNode("span", _hoisted_4, [
          _createVNode(_component_el_button, {
            size: "small",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.dialogInvoiceDetail = false))
          }, {
            default: _withId(() => [
              _hoisted_5
            ]),
            _: 1
          })
        ])
      ]),
      default: _withId(() => [
        _createVNode(_component_InvoiceDetailPage, { item: _ctx.dataItem }, null, 8, ["item"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "Pay Now",
      modelValue: _ctx.isShowPayNowPopup,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.isShowPayNowPopup = $event)),
      width: "800px"
    }, {
      default: _withId(() => [
        _createVNode("div", _hoisted_6, [
          _createVNode("h4", null, "Confirm payment of $" + _toDisplayString(_ctx.selectedInvoice.total) + ", this will be debited immediately from " + _toDisplayString(_ctx.cardInfo) + ".", 1),
          _hoisted_7
        ]),
        _createVNode("footer", _hoisted_8, [
          _createVNode(_component_el_button, {
            size: "small",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isShowPayNowPopup = false))
          }, {
            default: _withId(() => [
              _hoisted_9
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            size: "small",
            onClick: _ctx.handleAuthorize
          }, {
            default: _withId(() => [
              _hoisted_10
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
})